export const dataURLtoBlob = function(dataUrl: string) {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)![1];
  const binaryString = atob(arr[1]);
  let binaryStringLength = binaryString.length;
  const u8arr = new Uint8Array(binaryStringLength);
  while (binaryStringLength--) {
    u8arr[binaryStringLength] = binaryString.charCodeAt(binaryStringLength);
  }
  return new Blob([u8arr], { type: mime });
};

export const blobToDataURL = (blob: Blob): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = _e => resolve(reader.result as string);
    reader.onerror = _e => reject(reader.error);
    reader.onabort = _e => reject(new Error('Read aborted'));
    reader.readAsDataURL(blob);
  });
};
